export default __webpack_public_path__ + "static/media/black_steel.cc516f7e.svg";